<div class="container">
  <div class="wrap">
    <div class="working-hours">
      <div class="working-hours__title">
        <h3>{{ 'pages.restaurantAccount.workingHours' | translate }}</h3>
      </div>

      <div class="hours-skeleton" *ngIf="loading">
        <div class="hours-skeleton__labels">
          <ngx-skeleton-loader animation="progress"></ngx-skeleton-loader>
          <ngx-skeleton-loader animation="progress"></ngx-skeleton-loader>
        </div>
        <div class="hours-skeleton__row" *ngFor="let i of [].constructor(3)">
          <ngx-skeleton-loader animation="progress"></ngx-skeleton-loader>
          <ngx-skeleton-loader animation="progress"></ngx-skeleton-loader>
          <ngx-skeleton-loader animation="progress"></ngx-skeleton-loader>
        </div>
      </div>

      <ng-container *ngIf="!loading">
        <div class="working-hours__label" *ngIf="workingHours.length || isEditPeriods">
          <h3 class="working-hours__label__element">{{ 'pages.restaurantAccount.periodStart' | translate }}</h3>
          <h3 class="working-hours__label__element">{{ 'pages.restaurantAccount.periodEnd' | translate }}</h3>
        </div>

        <app-restaurant-schedule
          *ngFor="let period of workingHours"
          [period]="period"
          [periods]="workingHours"
          [editable]="editable"
          (update)="updatePeriod($event)"
          (delete)="deletePeriod($event)"
        >
        </app-restaurant-schedule>

        <div class="period__empty" *ngIf="!isEditPeriods">
          <span class="noPeriods" *ngIf="!workingHours.length">{{ 'period.workingTime.noPeriods' | translate }}</span>
          <button class="btn btn__primary btn__icon" *ngIf="editable" (click)="isEditPeriods = true">
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M8 1V15" stroke="currentColor" stroke-width="1.5" stroke-linecap="square" stroke-linejoin="round"/>
              <path d="M0.999878 8H14.9999" stroke="currentColor" stroke-width="1.5" stroke-linecap="square" stroke-linejoin="round"/>
            </svg>
            <span class="add">{{ 'period.workingTime.add' | translate }}</span>
          </button>
        </div>

        <app-restaurant-schedule
          *ngIf="isEditPeriods"
          [periods]="workingHours"
          (newPeriod)="createPeriod($event)"
          (cancel)="isEditPeriods = $event"
        >
        </app-restaurant-schedule>
      </ng-container>
    </div>
  </div>
</div>
